function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m4 118 21.615-29.987c4.846-6.723 13.987-8.698 21.176-4.577l13.85 7.939c7.7 4.414 17.519 1.802 22.008-5.854l15.798-26.94c4.511-7.693 14.398-10.286 22.105-5.797l12.789 7.45c7.34 4.274 16.736 2.147 21.519-4.872L181 17",
  stroke: "url(#arrow-curve)",
  strokeWidth: 6.936,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m160.713 26.464 19.581-14.205c2.36-1.713 5.558.505 4.781 3.315l-6.442 23.318",
  stroke: "url(#arrow-head)",
  strokeWidth: 6.936,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "arrow-curve",
  x1: 92.5,
  y1: 39.311,
  x2: 92.5,
  y2: 118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "arrow-head",
  x1: 187.419,
  y1: 7.089,
  x2: 169.673,
  y2: 32.678,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})));

function SvgPinkArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 122,
    viewBox: "0 0 197 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkArrow);
export default __webpack_public_path__ + "static/media/pink-arrow.03cf876b5046207a388433a185583d9a.svg";
export { ForwardRef as ReactComponent };